// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Expander_wrapper__2znB8"};